"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HouseholdsService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class HouseholdsService {
    /**
     * @returns Household List of households for the logged in user
     * @throws ApiError
     */
    static getHouseholds() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/households',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Household The new household
     * @throws ApiError
     */
    static createHousehold(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/households',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param householdId
     * @param requestBody
     * @returns Household Ok
     * @throws ApiError
     */
    static updateHousehold(householdId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/households/{householdId}',
            path: {
                'householdId': householdId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param householdId
     * @param requestBody
     * @returns HouseholdPerson The new household person
     * @throws ApiError
     */
    static createHouseholdPerson(householdId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/households/{householdId}/members',
            path: {
                'householdId': householdId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param householdId
     * @param householdPersonId
     * @returns any Household person deleted
     * @throws ApiError
     */
    static deleteHouseholdPerson(householdId, householdPersonId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/households/{householdId}/members/{householdPersonId}',
            path: {
                'householdId': householdId,
                'householdPersonId': householdPersonId,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param householdId
     * @param householdPersonId
     * @returns HouseholdPerson The household person that was re-invited
     * @throws ApiError
     */
    static resendInvite(householdId, householdPersonId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/households/{householdId}/members/{householdPersonId}/resend_invite',
            path: {
                'householdId': householdId,
                'householdPersonId': householdPersonId,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param householdId
     * @param householdPersonId
     * @returns any Household person invite deleted
     * @throws ApiError
     */
    static deleteInvite(householdId, householdPersonId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/households/{householdId}/members/{householdPersonId}/invite',
            path: {
                'householdId': householdId,
                'householdPersonId': householdPersonId,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param inviteToken
     * @param requestBody
     * @returns any The updated household person
     * @throws ApiError
     */
    static updateInvite(inviteToken, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/household_invites/{inviteToken}',
            path: {
                'inviteToken': inviteToken,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.HouseholdsService = HouseholdsService;
